import { number, oneOfType, string } from 'prop-types'
import { Skeleton as MUISkeleton } from '@mui/material'

const Skeleton = ({ variant = 'rectangular', width = 100, ...props }) => (
  <MUISkeleton
    {...{
      variant,
      width,
      ...props,
    }}
  />
)
export default Skeleton

Skeleton.propTypes = {
  variant: string,
  width: oneOfType([string, number]),
}
